// extracted by mini-css-extract-plugin
export default {"container":"openEditor_container__39-9b"};